export default __webpack_public_path__ + "static/media/DimaCh11.493b84ad.svg";